module.exports = __webpack_public_path__ + "img/E727805E-123F-4097-B352-E146F118D74B_1_201_a-min.599dd727.jpeg";